import { createContext, useContext } from 'react';
import type { SidebarFavourite } from '../favouritesStore';

/** A row this panel currently shows to this user — the only rows a favourite may resolve to. */
export interface FavouriteCandidate extends SidebarFavourite {
  active: boolean;
}

export interface PanelFavourites {
  items: readonly SidebarFavourite[];
  isFavourite: (id: string) => boolean;
  toggle: (fav: SidebarFavourite) => void;
}

export const PanelFavouritesContext = createContext<PanelFavourites | null>(null);

/** Null outside a panel, so a row rendered elsewhere simply has no star. */
export function usePanelFavourites(): PanelFavourites | null {
  return useContext(PanelFavouritesContext);
}
